import { Base } from 'layouts'
import { ClientForm } from 'components/Client/ClientForm'

import * as S from './styled'

export function ClientEdit() {
  return (
    <Base>
      <S.GridContainer container>
        <ClientForm />
      </S.GridContainer>
    </Base>
  )
}
